import styled from '@emotion/styled';

// Local Typings
export interface DialogContentProps {
  fullWidth?: boolean;
  minWidth?: number;
  noPaddingBottom?: boolean;
  noPaddingLeft?: boolean;
  noPaddingRight?: boolean;
  noPaddingTop?: boolean;
}

// Component Definition
const DialogContent = styled.div<DialogContentProps>(props => ({
  height: '100%',
  minWidth: props.minWidth,
  paddingBottom: props.noPaddingBottom ? 0 : props.theme.spacing * 6,
  paddingLeft: props.noPaddingLeft ? 0 : props.theme.spacing * 6,
  paddingRight: props.noPaddingRight ? 0 : props.theme.spacing * 6,
  paddingTop: props.noPaddingTop ? 0 : props.theme.spacing * 6,
  width: props.fullWidth ? '100%' : undefined,
}));

export default DialogContent;
